<template>
    <div>
        <h1 class="page-title">
            Cookie Policy
        </h1>

        <h2>What is a cookie?</h2>

        <p>
            A cookie is a small piece of unique information which acts as an ID tag. These are automatically issued to
            your computer when you visit a website. A cookie will store and sometimes track various information about
            the pages you visit, and information you voluntarily give to the website. When you enter My Online Estate
            Agent (<a href="https://app.myonlineestateagent.com/">app.myonlineestateagent.com</a>) our web server will
            send a cookie to your computer. This works on two levels, it allows us to recognise your computer and then
            display relevant information based on your past visit. For example if you have partly filled in your log-in
            details it will remember this, meaning you do not have to refill these fields again at a later date, saving
            you time.
        </p>
        <p>
            By proceeding past this page you consent to our cookie policies and settings and agree that you now
            understand our Cookie Policy. We will now outline in more detail why we use cookies and how you can manager
            them. Please be aware that if you opt to restrict your cookie settings then this will impact on your user
            experience. This may prevent you from using some of our valuable services which we have set up for your
            convenience.
        </p>

        <h2>Why does My Online Estate Agent use cookies?</h2>

        <p>
            If you navigate away from our property details page when it is only part completed a cookie will be stored.
            When you return, the information you had previously added will display, ready for you to complete. If you
            choose to not accept this cookie and you have not saved this page you will have to enter these details
            again.
        </p>
        <p>
            From time-to-time we may collect information about how you use My Online Estate Agent (
            <router-link :to="{ name: 'dashboard' }">
                app.myonlineestateagent.com
            </router-link>
            ). This is only used to make improvements and enhance the quality of our website and services we provide.
            This could include:
        </p>

        <ul>
            <li>Overall statistics on how you use our website.</li>
            <li>Tracking where you click on a page to understand the effectiveness of the page.</li>
            <li>
                Provide feedback to our chosen third-party partners. As we partner with the UK’s top property websites
                this information would only be shared with a third-party website that is providing a service to you. For
                example Rightmove.
            </li>
            <li>Analysing products and services you have purchased</li>
            <li>Improving errors that may occur when you are browsing.</li>
        </ul>

        <p>
            Using a cookie provides us with the information we require to enhance your user experience with us. Our
            cookies will remember you if you have visited before and which services you have applied for. We can also
            use cookies to restore information you may have lost if you choose to return on a different browsing
            session. If we share any information acquired through cookies to third-parties it will be for the sole
            purpose of improving our services, products or function and never for any other purpose.
        </p>
        <p>
            As we use a network of websites to promote your property listing we may use information from your cookies to
            improve and offer more from our services to you. This information will automatically allow these sites to
            see that you have previous visited My Online Estate Agent (
            <router-link to="{ name: 'dashboard' }">
                app.myonlineestateagent.com
            </router-link>
            ) on a prior web browsing session. This information is also used to inform you of any other products and
            services provided by My Online Estate Agent that may be of interest to you.
        </p>
        <p>We never pass on potentially private or sensitive information through a cookie. Example – bank details.</p>

        <h2>How you can manage your cookie settings.</h2>

        <p>
            The cookies used on My Online Estate agent are all served by us. Most web browsers will automatically accept
            cookies. However, you can change your browser settings to notify each time a cookie is set. You can also
            delete all cookies by choosing this option from your ‘Internet Options’. Please be aware if you block or
            delete cookies then you may not get our full and best user experience.
        </p>
        <p>
            My Online Estate Agent uses Google Analytics, this is an analytical service which is provided by Google, Inc.
            Google Analytics operates using cookies to monitor browser usage, new visitors and responses to marketing
            for internal and external campaigns such as Google Ad Words. We use this information to understand your
            experience with us and to make improvements where we see fit. The data that is stored by these cookies will
            never show personal identifiable information and we never share this data with any third parties.
        </p>
        <p>
            My Online Estate Agent.com uses Google Analytics 1st party cookies with DoubleClick’s 3rd party cookies
            together to provide additional information on demographics and interests in our Google Analytics
            reporting.
        </p>
        <p>
            In addition to this information we also outline our cookie policy in our
            <router-link
                :to="{ name: 'privacy-policy' }"
                title="privacy policy"
            >
                Privacy policy
            </router-link>
        </p>
        <p>
            We believe that as our customer you are our most valuable and important client. We continually strive to
            develop and improve our services by using the latest technology. Our cookie policy may change in any future
            updates. We will always update our Cookie Policy and
            <router-link
                title="privacy policy"
                :to="{ name: 'privacy-policy' }"
            >
                Privacy Policy
            </router-link>
            to reflect this.
        </p>
    </div>
</template>

<script>

export default {
    name: 'CookiePolicy'
};
</script>

<style lang="scss">

</style>
